import React, { FunctionComponent } from "react";
import { NumberField } from "components/fields/NumberField";
import { Trans } from "@lingui/macro";
import { useAangifte } from "components/aangifte/AangifteProvider";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";

export interface Props {}

export const VoorafbetalingenForm: FunctionComponent<Props> = () => {
  const {
    aangifte: { isGemeenschappelijkeAangifte, rubrieken },
  } = useAangifte();

  const sumCodes = (codes: string[]) => {
    return pipe(
      codes,
      array.map((code) => (rubrieken.get(code)?.value as number) || 0),
      array.reduce(0, (acc, value) => acc + value),
      (num) => num.toFixed(2)
    );
  };
  return (
    <div id="vooraf" className="breed">
      <div className="vooraf" id="vooraf_declarant">
        <div className="titel">
          <Trans>De aangever</Trans>
        </div>
        <div className="veld">
          <NumberField name="1571" />
        </div>
        <div className="veld">
          <NumberField name="1572" />
        </div>
        <div className="veld">
          <NumberField name="1573" />
        </div>
        <div className="veld">
          <NumberField name="1574" />
        </div>
        <div className="veld" style={{ width: 60 }}>
          {sumCodes(["1571", "1572", "1573", "1574"])}
        </div>
      </div>
      {isGemeenschappelijkeAangifte && (
        <div className="vooraf" id="vooraf_partner">
          <div className="titel">
            <Trans>De partner</Trans>
          </div>
          <div className="veld">
            <NumberField name="2571" />
          </div>
          <div className="veld">
            <NumberField name="2572" />
          </div>
          <div className="veld">
            <NumberField name="2573" />
          </div>
          <div className="veld">
            <NumberField name="2574" />
          </div>
          <div className="veld" style={{ width: 60 }}>
            {sumCodes(["2571", "2572", "2573", "2574"])}
          </div>
        </div>
      )}

      <div className="vooraf">
        <div className="titel">
          <Trans>Uitgevoerd voor:</Trans>
        </div>
        <div className="veld">
          <p>VA 1</p>
        </div>
        <div className="veld">VA 2</div>
        <div className="veld">VA 3</div>
        <div className="veld">VA 4</div>
        <div className="veld" style={{ width: 60 }}>
          <Trans>Totaal</Trans>
        </div>
      </div>
    </div>
  );
};

VoorafbetalingenForm.displayName = "VoorafbetalingenForm";
